import React from "react";
import { ProductConsumer } from "../../../Context/AddProWakel";
import NumberFormat from "react-number-format";

const FooterOfRozhana = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const {
            d_paraynadrawID,
            d_paraynadraw$,
            d_wargrtnawayQarzID,
            d_wargrtnawayQarz$,
            d_paraywargerawID,
            d_paraywargeraw$,
            d_froshrawID,
            d_froahraw$,
            d_rahelID,
            d_rahel$,
            d_yassinID,
            d_yassin$,
            d_koyparadandolar,
            d_koyparadandinar,
            d_koyparadanRRR,
            d_koyparakomdolar,
            d_koyparakomdinar,
            d_koyparakomRRR
          } = value;
          return (
            <>
              <br />
              <div className="row">
                <div className="col-12 " style={{ border: "2px solid black" }}>
                  <div className="row ">
                    <div className="col-2">
                      <h4 className="text-black tc">پارەی نەدراو</h4>
                    </div>

                    <div className="col-2">
                      <h4 className="text-black">قەرز</h4>
                    </div>

                    <div className="col-2">
                      <h4 className="text-black tc">پارەی وەرگیراو</h4>
                    </div>

                    <div className="col-2">
                      <h4 className="text-black tc">فرۆشراوەکان</h4>
                    </div>

                    <div className="col-2">
                      <h4 className="text-black tc">یوسف</h4>
                    </div>

                    <div className="col-2">
                      <h4 className="text-black tc">ئەنوەر</h4>
                    </div>
                  </div>
                </div>
              </div>
              {/* second row */}
              <div className="row">
                <div className="col-12" style={{ border: "2px solid black" }}>
                  <div className="row mb2">
                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_paraynadraw$}
                          prefix="$"
                        />
                      </h3>
                    </div>

                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_wargrtnawayQarz$}
                          prefix="$"
                        />
                      </h3>
                    </div>

                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_paraywargeraw$}
                          prefix="$"
                        />
                      </h3>
                    </div>

                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_froahraw$}
                          prefix="$"
                        />
                      </h3>
                    </div>

                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_yassin$}
                          prefix="$"
                        />
                      </h3>
                    </div>

                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_rahel$}
                          prefix="$"
                        />
                      </h3>
                    </div>
                  </div>
                </div>
              </div>

              {/* third row */}
              <div className="row">
                <div className="col-12" style={{ border: "2px solid black" }}>
                  <div className="row ">
                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_paraynadrawID}
                          prefix="ID"
                        />
                      </h3>
                    </div>

                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_wargrtnawayQarzID}
                          prefix="ID"
                        />
                      </h3>
                    </div>

                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_paraywargerawID}
                          prefix="ID"
                        />
                      </h3>
                    </div>

                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_froshrawID}
                          prefix="ID"
                        />
                      </h3>
                    </div>

                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_yassinID}
                          prefix="ID"
                        />
                      </h3>
                    </div>

                    <div className="col-2">
                      <h3 style={{ padding: "5px 30px" }} className="bg-white">
                        <NumberFormat
                          displayType="text"
                          className="bg-white f4 font-weight-bold   border-0"
                          thousandSeparator={true}
                          value={d_rahelID}
                          prefix="ID"
                        />
                      </h3>
                    </div>
                  </div>
                </div>
              </div>
              {/* second row */}
              <br />
              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="row ">
                    <div className="col-lg-2  col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparadandolar}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-3 col-3">
                      <h3 className="text-black tc ">$کۆی پارەدان</h3>
                    </div>

                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparakomdolar}
                          prefix={"$"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-2 col-3">
                      <h3 className="text-black tc">مافی کۆمپانا</h3>
                    </div>

                    <div className="col-lg-2 col-2"></div>
                    <div className="col-lg-2 col-2"></div>
                  </div>
                </div>
              </div>

              {/* third row */}
              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="row ">
                    <div className="col-lg-2 col-2 ">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparadandinar}
                          className=" f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-3 col-4">
                      <h3 className="text-black tc">IDکۆی پارەدان</h3>
                    </div>

                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparakomdinar}
                          prefix={"ID"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>

                    <div className="col-lg-1 col-3"></div>

                    <div className="col-lg-2 col-3"></div>

                    <div className="col-lg-1 col-3"></div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-lg-12 col-12">
                  <div className="row ">
                    <div className="col-lg-2 col-2 ">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparadanRRR}
                          className=" f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>
                    <div className="col-lg-3 col-4">
                      <h3 className="text-black tc">Rکۆی پارەدان</h3>
                    </div>

                    <div className="col-lg-2 col-3">
                      <h3 className="bg-white tc">
                        <NumberFormat
                          value={d_koyparakomRRR}
                          prefix={"R"}
                          className="bg-white f4 font-weight-bold  tc border-0"
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                      </h3>
                    </div>

                    <div className="col-lg-1 col-3"></div>

                    <div className="col-lg-2 col-3"> </div>

                    <div className="col-lg-1 col-3"></div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FooterOfRozhana;
